// store/news/reducers/update-product-reducer.js

import {
    RESET_UPDATE_PRODUCT_STATE,
    UPDATE_PRODUCT_FAILURE,
    UPDATE_PRODUCT_REQUEST,
    UPDATE_PRODUCT_SUCCESS
} from "../actions/update-product-actions";

const initialState = {
    loading: false,
    response: null,
    error: null,
    isUpdated: false
};

export default function updateProductReducer(state = initialState, action) {
    switch (action.type) {
        case UPDATE_PRODUCT_REQUEST:
            return {...state, loading: true, error: null, isUpdated: false};
        case UPDATE_PRODUCT_SUCCESS:
            return {...state, loading: false, response: action.payload, isUpdated: true};
        case UPDATE_PRODUCT_FAILURE:
            return {...state, loading: false, error: action.payload, isUpdated: false};
        case RESET_UPDATE_PRODUCT_STATE:
            return {
                ...state,
                loading: false,
                response: null,
                error: null,
                isUpdated: false
            };
        default:
            return state;
    }
}
